import React from "react";
import SEO from "@/components/common/SEO";
import Hero from "@/components/sections/Hero";
import CredibilityStrip from "@/components/sections/CredibilityStrip";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import ServicesSection from "@/components/sections/ServicesSection";
import ProblemSolution from "@/components/sections/ProblemSolution";
import ProcessTimeline from "@/components/sections/ProcessTimeline";
import MarketsSection from "@/components/sections/MarketsSection";
import IndustriesSection from "@/components/sections/IndustriesSection";
import WhyChoose from "@/components/sections/WhyChoose";
import AboutPreview from "@/components/sections/AboutPreview";
import ReviewsPlaceholder from "@/components/sections/ReviewsPlaceholder";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import { company, contact, faqs } from "@/config/site";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: company.legalName,
  alternateName: company.name,
  url: `https://${company.domain}`,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Karachi",
    addressCountry: "PK",
  },
  location: [
    { "@type": "Place", address: { "@type": "PostalAddress", addressLocality: "Karachi", addressCountry: "PK" } },
    { "@type": "Place", address: { "@type": "PostalAddress", addressLocality: "Dubai", addressCountry: "AE" } },
  ],
  telephone: contact.phone,
  email: contact.email,
  description:
    "Premier Global Sourcing supports businesses with product sourcing, supplier coordination, international trading and logistics planning with an international team.",
};

const combinedJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    jsonLd,
    {
      "@type": "FAQPage",
      mainEntity: faqs.slice(0, 6).map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="Global Sourcing & Trading Company | Premier Global Sourcing"
        description="Premier Global Sourcing supports businesses with product sourcing, supplier coordination, international trading and logistics planning with an international team."
        path="/"
        jsonLd={combinedJsonLd}
      />
      {/* Hidden SEO H1 element already visually present in hero; ensure the semantic H1 exists */}
      <Hero />
      <CredibilityStrip />
      <ServicesSection chapter="01" />
      <EditorialMarquee />
      <ProblemSolution chapter="02" />
      <ProcessTimeline chapter="03" />
      <MarketsSection chapter="04" />
      <IndustriesSection chapter="05" />
      <WhyChoose chapter="06" />
      <AboutPreview />
      <ReviewsPlaceholder />
      <FAQ chapter="07" limit={8} />
      <FinalCTA />
    </>
  );
}
